export default "ui-brandName = { -product-name }\n";